import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {Product} from '../models/product';
import {Waiting} from '../models/waiting';
import {ConfigService} from '../services/config.service';
import {ProductService} from '../services/product.service';
import {WaitingListService} from '../services/waiting-list.service';
import {WaitingListDialogComponent} from './dialogs/waiting-list-dialog/waiting-list-dialog.component';
import {FileService} from '../services/file.service';

@Component({
  selector: 'app-waiting-list',
  templateUrl: './waiting-list.component.html',
  styleUrls: [ './waiting-list.component.scss' ]
})
export class WaitingListComponent implements OnInit {

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  // public displayedColumns: string[] = ['icon', 'product', 'member', 'allowed', 'edit'];
  public displayedColumns: string[] = [ 'icon', 'date', 'member', 'category', 'allowed', 'edit' ];



  public products: Product[] = []
  public selectedProduct: any = {};
  public dataSource: MatTableDataSource<any>;
  public prod_name: string;


  constructor (
    private dialog: MatDialog,
    private _fileService: FileService,
    private _productService: ProductService,
    private _configService: ConfigService,
    private _WaitingListService: WaitingListService

  ) {
    this.loadProducts()
  }

  ngOnInit () {
    this._configService.loadConfigs()
  }


  selectByProduct (event) {
    console.log(event)

    let product_id = event
    this._WaitingListService.loadWaitingList(product_id)
      .subscribe((result) => {

        let array: any[] = []

        result.forEach((item) => {

          let entity: Waiting = new Waiting()

          let dt: any = null
          if (item.payload.doc.data().createdAt)
            dt = item.payload.doc.data().createdAt

          entity.id = item.payload.doc.id;
          entity.createdAt = dt ? dt.toDate() : dt;
          entity.waiting = item.payload.doc.data().waiting;
          entity.allowed = item.payload.doc.data().allowed;

          entity.product_id = item.payload.doc.data().product.id;
          entity.product_name = item.payload.doc.data().product.data.name;

          this.prod_name = entity.product_name

          entity.member_id = item.payload.doc.data().member.id;
          entity.member_name = item.payload.doc.data().member.data.name;
          entity.member_email = item.payload.doc.data().member.data.email;

          entity.category_id = item.payload.doc.data().member.data.category_id;
          entity.category_name = item.payload.doc.data().member.data.category_name;

          array.push(entity)
        })

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.sort = this.sort;

        //console.log('------------------ ' + array.length)

      })

  }

  loadProducts () {

    return this._productService.selectProducts()
      .subscribe((result) => {

        result.forEach((item) => {
          if (item.payload.doc.data().part_of != 3) {
            let product = new Product();
            product.id = item.payload.doc.id;
            product.name = item.payload.doc.data().name;
            product.text = item.payload.doc.data().text;
            product.image = item.payload.doc.data().image;
            product.active = item.payload.doc.data().active;
            this.products.push(product)
          }
        })

      })
  }

  openDialog (entity) {

    let data: Waiting = new Waiting();

    if (entity) {
      data = entity;
    }

    this.dialog.open(WaitingListDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }

  exportCSV () {
    const data: any = this.dataSource.data


    let csvFile: any[] = []

    csvFile.push("" + ";" + "SBCCV - Lista Espera " + this.prod_name + '\r\n')

    let csvHeader: string;
    csvHeader = "" + ";"
    csvHeader += 'Data' + ';'
    csvHeader += 'Nome' + ';'
    csvHeader += 'Email' + ';'
    csvHeader += 'Categoria' + ';'
    csvHeader += 'Espera' + ';'
    csvHeader += 'Liberado' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((line) => {
      let csvLine: string;
      csvLine = "" + ";"
      csvLine += this.formatDate(line.createdAt) + ";"
      csvLine += line.member_name + ";"
      csvLine += line.member_email + ";"
      csvLine += line.category_name + ";"
      csvLine += line.waiting ? 'Sim;' : 'Não;'
      csvLine += line.allowed ? 'Sim\r\n' : 'Não\r\n'

      csvFile.push(csvLine)
    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});
    this._fileService.saveFile(blob, "lista_espera.csv");
  }

  formatDate (date: Date) {

    if (date) {
      let dt = date.toISOString()
      console.log(dt)
      let dd: any = dt.substring(8, 10);
      let mm: any = dt.substring(5, 7);
      let yy: any = dt.substring(0, 4);
      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

}
